import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { APP } from 'src/Configs/App'

export const artistSpotifyApi = createApi({
  reducerPath: 'artistSpotifyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: APP.TIKTOK_SERVER,
  }),
  endpoints: (builder) => ({
    updateUserSpotifyArtist: builder.mutation<
      void,
      { artistSpotifyId: string; token: string }
    >({
      query: ({ artistSpotifyId, token }) => ({
        url: `/artist/user-spotify-artists/${artistSpotifyId}`,
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
})

export const { useUpdateUserSpotifyArtistMutation } = artistSpotifyApi
